<app-grid
entity='account'
[filters]='this.siteFilters'
[columns]='this.siteColumns'
[buttons]='this.siteButtons'
[searchFilters]='this.siteSearchFilters'
[searchFields]='this.siteSearchFields'
[inverse]='true'
></app-grid>
